/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { LS_TOP_TRADERS_KEY } from './Table';

interface ITableWidths {
  '№': number;
  wallet: number;
  avgUsdBuy: number;
  avgUsdSell: number;
  volumeUSD: number;
  botCount: number;
  statistics: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  '№': 40,
  wallet: 120,
  avgUsdBuy: 110,
  avgUsdSell: 150,
  volumeUSD: 150,
  botCount: 130,
  statistics: 90,
};

const useTableData = ({ wallets }: any) => {
  const tableWidthsLC = localStorage.getItem(LS_TOP_TRADERS_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => wallets, [wallets]);
  const columns = React.useMemo(
    () => [
      {
        id: '№',
        Header: '№',
        accessor: '№',
        width: tableColumnsWidth['№'] || tableWidthsDefaultState['№'],
      },
      {
        id: 'wallet',
        Header: 'Wallet',
        accessor: 'wallet',
        disableSortBy: true,
        filterValue: '',
        width: tableColumnsWidth['wallet'] || tableWidthsDefaultState['wallet'],
      },
      {
        id: 'avgUsdBuy',
        Header: 'Avg Buy Price ($)',
        accessor: 'avg_usd_buy',
        width:
          tableColumnsWidth['avgUsdBuy'] ||
          tableWidthsDefaultState['avgUsdBuy'],
      },
      {
        id: 'avgUsdSell',
        Header: 'Avg Sell Price ($)',
        accessor: 'avg_usd_sell',
        width:
          tableColumnsWidth['avgUsdSell'] ||
          tableWidthsDefaultState['avgUsdSell'],
      },
      {
        id: 'volumUSD',
        Header: 'Trading Volume ($)',
        accessor: 'volume_usd',
        width:
          tableColumnsWidth['volumeUSD'] ||
          tableWidthsDefaultState['volumeUSD'],
      },
      {
        id: 'botCount',
        Header: 'Bot TX',
        accessor: 'bot_count',
        width:
          tableColumnsWidth['botCount'] || tableWidthsDefaultState['botCount'],
      },
      {
        id: 'statistics',
        Header: 'Statistics',
        accessor: 'statistics',
        disableSortBy: true,
        width:
          tableColumnsWidth['statistics'] ||
          tableWidthsDefaultState['statistics'],
      },
    ],
    []
  );

  return { columns, data, tableColumnsWidth };
};

export { useTableData };
